import React, {useEffect}      from 'react'
import {useLocation}           from 'react-router-dom'
import useExpiryCountdown      from '../../hooks/useExpiryCountdown'
import {studyModeFor}          from '../layout/AppLayout'
import TrialBanner             from './TrialBanner'

const millisecondsIn24Hours = 24 * 60 * 60 * 1000

/*
 * Decides whether the NAVBAR chip is on screen, and reports expiry upward (169).
 *
 * Mounted once in PrepKit, which wraps the dashboard and every study screen through its <Outlet/>,
 * so this single mount covers them all.
 *
 * It renders only the navbar chip, and only OUTSIDE the dashboard (170):
 *
 *   study-mode route  ->  the chip. That is where a trial is actually spent, and the brief requires
 *                         the navbar form there.
 *   the dashboard     ->  nothing here. The dashboard puts the countdown in its greeting row, beside
 *                         "Welcome back", which is always on screen — so there is no case left where
 *                         the dashboard needs the chip as well.
 */
const ExpiringPrepKit = ({prepKit, onBuy, onPrepKitExpired}) => {

	const {pathname} = useLocation()
	const {msLeft, expired} = useExpiryCountdown(prepKit && prepKit.expires_at)

	useEffect(() => {
		if (prepKit && expired) {
			onPrepKitExpired(prepKit)
		}
	}, [prepKit, expired])

	if (!prepKit || expired) return null

	const isTrial = Boolean(prepKit.is_trial)

	/*
	 * A trial counts down for its whole life -- it is 35 minutes long and converting is the point.
	 * A paid PrepKit only counts down inside its last 24 hours, or a year-long kit would carry a
	 * countdown all year.
	 */
	if (!isTrial && msLeft >= millisecondsIn24Hours) return null

	// the dashboard owns its own countdown; see the note above
	if (!studyModeFor(pathname)) return null

	return <TrialBanner variant="navbar" msLeft={msLeft} isTrial={isTrial} onBuy={onBuy}/>
}

export default ExpiringPrepKit
